import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./slice/authSlice";
import headerReducer from "./slice/headerSlice";
import membershipSlice from "./slice/membershipSlice";
import homeSlice from "./slice/homeSlice";
import transactionSlice from "./slice/transactionSlice";
import giftcardSlice from "./slice/giftcardSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    header: headerReducer,
    membership: membershipSlice.reducer,
    home: homeSlice.reducer,
    transactions: transactionSlice.reducer,
    giftcard: giftcardSlice.reducer,
  },
});

export default store;
